import { ReactNode } from 'react';
import { Space } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import Button from 'components/new-ui/base/button/Button';
import { H3 } from 'components/new-ui/base/typography/styles';

type Props = {
    title: string;
    isExpanded: boolean;
    onToggle: () => void;
    children: ReactNode;
};

const OptionalSection = ({ title, isExpanded, onToggle, children }: Props) => (
    <section>
        <Space size={16} direction="vertical" style={{ width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <H3>
                    {title} <span style={{ fontWeight: 400 }}>(optional)</span>
                </H3>
                <Button
                    icon={isExpanded ? <MinusOutlined /> : <PlusOutlined />}
                    aria-expanded={isExpanded}
                    aria-label={`${isExpanded ? 'Hide' : 'Show'} ${title}`}
                    onClick={onToggle}
                />
            </div>

            <div
                style={{
                    display: 'grid',
                    gridTemplateRows: isExpanded ? '1fr' : '0fr',
                    transition: 'grid-template-rows 0.3s ease',
                }}
            >
                <div style={{ overflow: 'hidden' }}>
                    <Space size={6} direction="vertical" style={{ width: '100%' }}>
                        {children}
                    </Space>
                </div>
            </div>
        </Space>
    </section>
);

export default OptionalSection;
